import { DriverBreakdownOverTimeFragments } from '../queries/insights/RoutesBreakdownByDriverOverTime';

export enum Metric {
  COMPLETED_ROUTES = 'completed-routes',
  COMPLETED_ORDERS = 'completed-orders',
  ESTIMATED_DISTANCE = 'estimated-distance',
  WORKING_TIME = 'working-time',
}

export const metricsToFragmentsMapping: Record<Metric, keyof DriverBreakdownOverTimeFragments> = {
  [Metric.COMPLETED_ROUTES]: 'completedRoutes',
  [Metric.COMPLETED_ORDERS]: 'completedOrders',
  [Metric.ESTIMATED_DISTANCE]: 'estimatedDistanceCompleted',
  [Metric.WORKING_TIME]: 'completedWorkingTime',
};

export enum FilterDimension {
  DRIVERS = 'DRIVERS',
}

export const DRIVER_COUNT_THRESHOLD = 90;
